export const getLeadInquiries = (inquiries = [], leadId) => (
  inquiries.filter((inquiry) => inquiry.clientId === leadId)
);
